import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { ClipboardCheck, X } from "lucide-react";
import api from "../../lib/api";

const DECISIONES = ["Devolver o pedir canje al laboratorio", "Promocionar en el mostrador", "Retirar del lineal", "Ajustar pedidos y mínimos", "Revisar precios", "Otra"];

export function CrearAccion({ ind, onClose, onSaved }) {
  const [staff, setStaff] = useState([]);
  const [f, setF] = useState({ decision: DECISIONES[0], responsable: "", fecha_limite: "", nota: "" });
  useEffect(() => { api.get("/staff").then((r) => setStaff((r.data?.personal || []).filter((s) => s.estado !== "eliminado"))).catch(() => {}); }, []);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const guardar = async (e) => {
    e.preventDefault();
    try {
      await api.post("/acciones", { indicador: ind.key, indicador_label: ind.label, valor_inicial: typeof ind.value === "number" ? ind.value : null,
                                    enlace: ind.link || null, ...f, responsable: f.responsable || null, fecha_limite: f.fecha_limite || null, nota: f.nota || null });
      toast.success("Acción creada: la verás en el Cuadro de mando");
      onSaved?.();
      onClose();
    } catch { toast.error("No se pudo crear la acción"); }
  };
  return (
    <div className="fixed inset-0 z-[80] bg-slate-900/50 flex items-center justify-center p-4" onClick={onClose} data-testid="accion-modal">
      <form onSubmit={guardar} onClick={(e) => e.stopPropagation()} className="card bg-white p-6 w-full max-w-md space-y-3">
        <div className="flex items-center justify-between">
          <h3 className="font-display text-lg font-bold flex items-center gap-2"><ClipboardCheck size={18} /> Nueva acción</h3>
          <button type="button" onClick={onClose} data-testid="accion-cerrar"><X size={18} /></button>
        </div>
        <p className="text-xs text-slate-500">Sobre <b>{ind.label}</b>. Se guarda el valor de hoy para medir después si ha mejorado.</p>
        <label className="block text-xs font-semibold text-slate-600">Decisión
          <select className="input w-full mt-1" value={f.decision} onChange={set("decision")} data-testid="accion-decision">{DECISIONES.map((d) => <option key={d}>{d}</option>)}</select>
        </label>
        <label className="block text-xs font-semibold text-slate-600">Responsable
          <select className="input w-full mt-1" value={f.responsable} onChange={set("responsable")} data-testid="accion-responsable">
            <option value="">Titular</option>{staff.map((s) => <option key={s.vendedor} value={s.nombre || s.vendedor}>{s.nombre || s.vendedor}</option>)}
          </select>
        </label>
        <label className="block text-xs font-semibold text-slate-600">Fecha límite
          <input type="date" className="input w-full mt-1" value={f.fecha_limite} onChange={set("fecha_limite")} data-testid="accion-fecha" />
        </label>
        <textarea className="input w-full min-h-[70px]" placeholder="Nota (opcional)" value={f.nota} onChange={set("nota")} data-testid="accion-nota" />
        <button className="btn btn-primary w-full" data-testid="accion-guardar">Crear acción</button>
      </form>
    </div>
  );
}
